import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { RotatingSquare } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import JoditEditor from 'jodit-react';
const PlatformRulesEdit = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [sequence, setSequence] = useState("");
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(true);
    const [updateData, setupdateData] = useState([]);
    const [errorMessage, setErrorMessage] = useState([]);
    const refSubmitDis = useRef();

    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/platform-rules/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data?.data);
                setDisContent(data?.data?.description || "");
                setSequence(
                    data?.data?.sequence != null ? String(data?.data?.sequence) : ""
                );
                setStatus(
                    data?.data?.status != null ? String(data?.data?.status) : ""
                );
                setLoading(false);

            });
    }, [updateData]);

    const DisRef = useRef(null)
    const [Dis, setDisContent] = useState(data?.description)
    const [Image, setImage] = useState("");


    const handleImage = (e) => {
        setImage(e.target.files[0]);
    };

    const handleSubmitData = (event) => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        // Clear previous errors
        setErrorMessage({});

        try {

            const formData = new FormData(event.currentTarget);
            formData.set("description", Dis || "");
            // Append selected image
            if (Image) {
                formData.set("image", Image);
            }

            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };
            axios
                .put(
                    `https://api.velormall.com/api/admin/platform-rules/update/${id}`,
                    formData,
                    config
                )
                .then((response) => {

                    if (response?.data?.success) {
                        setupdateData(response?.data)
                        toast.success(`${response?.data.message}`, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        setImage('');
                        refSubmitDis.current.removeAttribute("disabled");

                    }

                })
                .then((data) => {
                    toast.success(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                })
                .catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });
        } catch (error) {

        }
    };

    if (loading) {
        return (
            <>
                <div className="loader-css">
                    <RotatingSquare
                        visible={true}
                        height="100"
                        width="100"
                        color="#4fa94d"
                        ariaLabel="rotating-square-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>
            </>
        );
    }
    return (
        <>
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Platform Rules Update</h6>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="card mb-4">
                        <form onSubmit={handleSubmitData}>
                            <div className="card-body">
                                <div className="payment-method-item">
                                    <div className="payment-method-body">
                                        <div className="row">
                                            <div className=" col-md-4 ">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">
                                                        Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        id="heading"
                                                        defaultValue={data?.name}
                                                    />
                                                    {errorMessage?.name && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.name?.msg}
                                                        </span>
                                                    )}
                                                </div>

                                            </div>
                                            <div className=" col-md-4 ">
                                                <div className="form-group">
                                                    <label htmlFor="role" className="required"> Sort By</label>
                                                    <select className="form-control" name="sequence" id="role"
                                                        value={sequence}
                                                        onChange={(e) =>
                                                            setSequence(e.target.value)
                                                        } >
                                                        <option value="" disabled>
                                                            Select Sequence
                                                        </option>

                                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((number) => (
                                                            <option key={number} value={number}>
                                                                {number}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errorMessage?.sequence && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.sequence?.msg}
                                                        </span>
                                                    )}
                                                </div>

                                            </div>
                                            <div className=" col-md-4 ">
                                                <div className="form-group">
                                                    <label htmlFor="role" className="required"> Status</label>
                                                    <select className="form-control" name="status" id="role" value={status}
                                                        onChange={(e) =>
                                                            setStatus(e.target.value)
                                                        }
                                                    >
                                                        <option value="" disabled>Select Status</option>
                                                        <option value="true">Active</option>
                                                        <option value="false">Inactive</option>
                                                    </select>
                                                    {errorMessage?.status && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.status?.msg}
                                                        </span>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Image</label>
                                                    <div className="image-upload">
                                                        <div className="thumb">
                                                            <div className="avatar-preview">
                                                                <div
                                                                    className="profilePicPreview"
                                                                    style={{ height: "120px" }}
                                                                >
                                                                    <img
                                                                        src={`https://api.velormall.com/${data?.image}`}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="avatar-edit">
                                                                <input
                                                                    type="file"
                                                                    onChange={handleImage}
                                                                    className="profilePicUpload"
                                                                    id="profilePicUpload0"
                                                                    accept=".jpg, .png, .jpeg"
                                                                />
                                                                <label
                                                                    htmlFor="profilePicUpload0"
                                                                    className="bg--primary"
                                                                >
                                                                    Image
                                                                </label>
                                                                <small class="mt-2  ">
                                                                    Supported files: <b>jpeg, jpg, png</b>. |
                                                                    Will be resized to:
                                                                    <b>800x800</b>
                                                                    px.
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="button_one_url" className="required"> Description</label>
                                        <JoditEditor
                                            ref={DisRef}
                                            value={Dis}
                                            height="600"
                                            onChange={(newContent) => setDisContent(newContent)}
                                        />
                                        {errorMessage?.description && (
                                            <span className="text-danger pt-2">
                                                {errorMessage?.description?.msg}
                                            </span>
                                        )}
                                    </div>

                                </div>
                            </div>
                            <div className="card-footer">
                                <button
                                    type="submit"
                                    ref={refSubmitDis}
                                    className="btn btn-primary w-100 h-45"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PlatformRulesEdit;
